import { closeAll } from "../utils/accordion";
import { $Q, $Qll } from "../utils/query-selector"
import { dataToggle } from "../utils/toggle-dataset";
import { readCart } from "./cart";

/**
 * Open dropdown menu - click / mouseentre event
 * To select type event check data-event in node#nav-list-js
 */
export function openDropDown() {
  const { dataset } = $Q('#nav-list-js');

  if (dataset.event === 'click' || innerWidth < 1300) {
    $Qll('.button-dropdown-js')
      .forEach(item => (
        eventDropDown(item, 'click', item)
      ))
  } else {
    $Qll('.nav-item-js')
      .forEach(item => {
        const container = item.children[1]

        eventDropDown(item, 'mouseenter', container.children[0])
        eventDropDown(item, 'mouseleave', container.children[0])
      })
  }
}

/**
 * Event dropDown
 * @param {HTMLElement} node - Event target node
 * @param {EventListener} event - Type event
 * @param {HTMLElement} nodeOnAction - Node to change data active
 * @returns Function Event
 */
function eventDropDown(
  node,
  event,
  nodeOnAction
) {
  return node.addEventListener(event, function () {
    dropDownAction(nodeOnAction)
  }, { passive: true })
}

/**
 * DropDown Action - if is not data active true
 * @param {HTMLElement} element - Node to change data active
 */
function dropDownAction(element) {
  element.dataset.active != 'true'
    && closeAll('.nav-item-js', $Q('#nav-list-js'));

  dataToggle(element);
}


/**
 * Get cart item count
 * Render quantity
 * @param {number} - cart item count
 * @author Daniel Santos
 */
export const updateHeaderCartCounter = async (counter = null) => {
  const counterElement = $Q('#js-header-cart-counter')

  if (!counterElement) return;

  let itemCount = counter

  if (!itemCount) {
    itemCount = await readCart()
    counterElement.textContent = `(${itemCount.item_count})`
    return;
  }

  counterElement.textContent = `(${itemCount})`
}

/**
 * Get total height of header and substract that value to nav height
 * @returns null
 * @author Daniel Santos
 */
export const calculateHeaderHeight = () => {
  const header = $Q('.section-header');
  const nav = $Q('#nav-list-js');

  if (!header && !nav) return;

  if (innerWidth < 1300) {
    nav.style.height = `calc(100% - ${header.offsetHeight}px`;
    nav.style.top = `${header.offsetHeight}px`;
  }
}
